module.exports = __webpack_public_path__ + "static/media/SmartShop_8-200w.0248aae7.png";